import { ReactElement } from 'react';
import { useForm } from 'react-hook-form';
import Box from '@mui/material/Box';

import useQuery from '~/store/medicationLogistics/hooks/useQuery';
import Checkbox from '~/ui/components/inputs/Checkbox';

import useQueryParam from '~/ui/pages/MedicationLogistics/hooks/useQueryParam';

import styles from './ShowCurrentTeamVisitCheckbox.module.scss';

interface IProps {
  label?: string;
}

const ShowCurrentTeamVisitCheckbox = ({
  label = "Show Current Team's Visits Only",
}: IProps): ReactElement => {
  const query = useQuery();
  const showCurrentTeamVisitsQuery = query.get('showCurrentTeamVisits');

  const {
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    defaultValues: {
      showCurrentTeamVisits: showCurrentTeamVisitsQuery
        ? showCurrentTeamVisitsQuery === 'true'
        : true,
    },
  });

  const showCurrentTeamVisits = watch('showCurrentTeamVisits');

  useQueryParam('showCurrentTeamVisits', showCurrentTeamVisits ? 'true' : 'false');

  return (
    <Box className={styles.container}>
      <Checkbox
        name="showCurrentTeamVisits"
        size="small"
        control={control}
        label={label}
        errors={errors}
      />
    </Box>
  );
};

export default ShowCurrentTeamVisitCheckbox;
